<div class="rx-procedure-tiles">
	<div class="tlk-header" *ngIf="title">{{ title | translate }}</div>
	<tiles
		data-testid="procedure-selector"
		[tiles]="tiles"
		[selectedTileId]="selectedProcedureId"
		[isDisabled]="isDisabled"
		(tileClicked)="tileClicked($event)"
	></tiles>
</div>
